import {Component, OnInit} from '@angular/core';
import {TranslationService} from '../../core/services/translation.service';
import {PaymentService} from '../../data/services/payment.service';
import {HupSubscriptionsService} from '../../data/services/hup-subscriptions.service';
import {HupSubscription} from '../../data/models/subscription.model';
import {Payment} from '../../data/models/payment.model';
import {NavigationCommand, NavigationService} from "../../data/services/navigation.service";
import {combineLatest, forkJoin, mergeMap, Observable, of} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {ConfigService} from "../../core/services/config.service";

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {

  isLoadingPayments: boolean = false;
  isLoadingSubs: boolean = false;
  errorsArr: string[] = [];
  displayPaymentChange: boolean = true;

  subs: HupSubscription[];
  payments: Payment[];

  constructor(private paymentService: PaymentService,
              private hupSubscriptionsService: HupSubscriptionsService,
              private navigationService: NavigationService,
              private configService: ConfigService,
              public translationService: TranslationService,
  ) {
  }

  ngOnInit(): void {
    this.isLoadingSubs = true;
    this.isLoadingPayments = true;

    this.hupSubscriptionsService.getSubscriptions()
      .pipe(
        mergeMap(subs => {
          this.subs = subs;
          this.isLoadingSubs = false;
          return combineLatest([of(subs), this.getFilteredBanks(subs)])
        }),
        catchError((error) => {
          this.errorsArr.push(this.translationService.getTranslation('error_subscription_init'));
          return of(null);
        })
      )
      .subscribe(res => {
        this.payments = res[1];
        this.isLoadingPayments = false;
      });

    let configValueString : string = this.configService.getConfig('payment.changeOfPaymentConditionsAllowed')?.value?? '1';
    console.log(configValueString)
    this.displayPaymentChange = configValueString !== '0';
  }

  getFilteredBanks(subs: HupSubscription[]) : Observable<Payment[]> {
    return this.paymentService.getPayments().pipe(
      map(
        ps => {
          let usedBanks: number[] = subs
            .map(s => s.curPayment?.bank?.backendId?? -1);
          return ps.filter(p => (p.bank.backendId ?? 1) <= 0 || usedBanks.includes(p.bank.backendId));
        }
      ),
      catchError((error) => {
        this.errorsArr.push(this.translationService.getTranslation('error_payment_init'));
        return of(null);
      })
    );
  }

  subPaymentEdit(sub: HupSubscription): void {
    this.navigationService.navigateTo(NavigationCommand.SUBPAYMENTEDIT, [sub.webId+'', sub.backendId+''])
  }

  paymentEdit(payment: Payment): void {
    this.navigationService.navigateTo(NavigationCommand.PAYMENTEDIT, [payment.webId+'', payment.bank.backendId+''])
  }

}
